class Blog extends HTMLElement {
    constructor() {
        super();
        this.filters_buttons = this.querySelectorAll('[data-filter-tag]');
        this.products_cards = this.querySelectorAll('[data-product-tag]');

        this.filters_buttons.forEach((button) => {

            button.addEventListener('click', this.changeCollection.bind(this));
        });

    }

    changeCollection(e) {

        this.filters_buttons.forEach((button) => {
            button.classList.remove('actif');
        });
        const tag = e.currentTarget.dataset.filterTag;
        e.currentTarget.classList.add('actif');


        if (tag == "all") {
            this.products_cards.forEach((card) => { card.classList.remove('hidden') });
        } else {
            this.products_cards.forEach((card) => {
                const product_tags = card.dataset.productTag;

                if (product_tags.includes(tag)) {
                    card.classList.remove('hidden');
                } else {
                    card.classList.add('hidden');
                }
            });
        }
    }
    findGetParameter(parameterName) {
        let queryString = window.location.search;

        if (queryString) {
            let urlParams = new URLSearchParams(queryString);

            let nom = urlParams.get(parameterName);

            return nom;
        }

    }
}

customElements.define('w-blog', Blog);